import axios from 'axios'
export default {
	namespaced: true,
	state: {
		publicaciones: []
	},
	getters: {
		publicaciones (state) {
			return state.publicaciones
		}
	},
	mutations: {
		SET_PUBLICACIONES (state, payload) {
			state.publicaciones = payload
		},
		APPEND_PUBLICACIONES (state, payload) {
			state.publicaciones = state.publicaciones.concat(payload)
		},
		ADD_PUBLICACION (state, payload) {
			state.publicaciones.splice(0, 0, payload)
		},
		UPDATE_PUBLICACION (state, payload) {
			state.publicaciones = state.publicaciones.map(pub => {
				if (pub.PublicacionID === payload.PublicacionID) {
					pub = payload
				}
				return pub
			})
		},
		DELETE_PUBLICACION (state, payload) {
			state.publicaciones = state.publicaciones.filter(pub => pub.PublicacionID !== payload.PublicacionID)
		}
	},
	actions: {
		recargar (context) {
			axios.get('muro/php/api/getPublicaciones.php')
				.then(res => {
					context.commit('SET_PUBLICACIONES', res.data)
				})
				.catch(e => {
					console.error(e)
				})
		},
		actualizarPublicacion (context, PublicacionID) {
			axios.get('muro/php/api/getPublicacion.php?PublicacionID=' + PublicacionID)
				.then(res => {
					context.commit('UPDATE_PUBLICACION', res.data)
				})
				.catch(e => {
					console.error(e)
				})
		},
		getPublicaciones (context, LastID) {
			axios.post('muro/php/api/getPublicaciones.php', {lastID: LastID})
				.then(res => {
					context.commit('APPEND_PUBLICACIONES', res.data)
				})
				.catch(e => {
					console.error(e.response.data.error)
				})
		},
		delPublicacion (context, PublicacionID) {
			axios.post('muro/php/api/delPublicacion.php', {PublicacionID: PublicacionID})
				.then(() => {
					context.commit('DELETE_PUBLICACION', {PublicacionID: PublicacionID})
				})
				.catch(e => {
					console.error(e.response.data.error)
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/muro/vue/store.js